<template>
    <div :class="ratingStarsClass">
        <div v-if="value">{{ value?.toFixed(1) }}</div>
        <div>
            <common-icon :class="ratingClass(1)" name="star" :size="iconSize"></common-icon>
            <common-icon v-if="type !== 'small'" :class="ratingClass(2)" name="star" :size="iconSize"></common-icon>
            <common-icon v-if="type !== 'small'" :class="ratingClass(3)" name="star" :size="iconSize"></common-icon>
            <common-icon v-if="type !== 'small'" :class="ratingClass(4)" name="star" :size="iconSize"></common-icon>
            <common-icon v-if="type !== 'small'" :class="ratingClass(5)" name="star" :size="iconSize"></common-icon>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: { type: Number, default: 0 },
            type: { type: String, default: 'primary' },
        },

        computed: {
            ratingStarsClass() {
                return {
                    'rating-stars': true,
                    [`rating-stars__type-${this.type}`]: true,
                }
            },

            iconSize() {
                if (this.type === 'primary') {
                    return 'semi-small'
                } else if (this.type === 'secondary') {
                    return 'small'
                }
                return 'large'
            },
        },

        methods: {
            ratingClass(starNumber) {
                return {
                    'rating-stars__star': true,
                    'rating-stars__star--empty': starNumber > Math.round(this.value),
                }
            },
        },
    }
</script>
